import { useCallback } from "react"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
import type {
  BigDataCenterVO,
  SpecializationVO,
  BusinessSceneList,
  SceneList,
  CompanyCustomerInsightVO,
  SelectedStoresItem,
} from "@/api"
import { SceneCustomerType } from "@/api"
import { defaultRange } from "@/constants/constant"
// ==============================================
interface ShopsAgs {
  moduleType: string
  shops: (SceneList | BusinessSceneList)[]
  activeShop?: SceneList
  // 区县
  districtId?: string
  // 街道
  streetId?: string
  // 网点半径
  radius: number
  // 网点半径范围
  radiusRange: number[]
  // 圆圈是否显示
  isCircleShow: boolean
  // 任务-选中店铺项
  selectedStores: SelectedStoresItem[]
  // 任务-KR弹窗是否显示
  isTaskShow: boolean
  // 任务-用户请求唯一标识
  uuid?: string
  // 场景拓客-客户洞察数据
  insightData?: CompanyCustomerInsightVO
  // 专精特新-row
  activeSpecialization?: SpecializationVO
  // 专精特新-列表数据
  specializationList: SpecializationVO[]
  // 大数据中心-列表数据
  bigDataCenterList: BigDataCenterVO[]
}
function useShops() {
  const [state, set] = useSetState<ShopsAgs>({
    moduleType: SceneCustomerType.COMPANY,
    shops: [],
    radius: defaultRange,
    radiusRange: [defaultRange],
    isCircleShow: false,
    selectedStores: [],
    isTaskShow: false,
    specializationList: [],
    bigDataCenterList: [],
  })
  const setAllState = useCallback(
    (value: Partial<ShopsAgs> | ((prevState: ShopsAgs) => Partial<ShopsAgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setAllState,
  }
}

export default createModel(useShops)
